import { type Contact } from "@/lib/types";

interface ContactOrganizationDetailsProps {
  contact: Contact;
}

export const ContactOrganizationDetails = ({
  contact,
}: ContactOrganizationDetailsProps) => {
  return (
    <table className="table table-auto border-spacing-2">
      <tbody>
        <tr className="table-row">
          <td>Founding year:</td>
          <td className="pl-2">{contact.organizationFoundingYear || "-"}</td>
        </tr>
        <tr className="table-row">
          <td>Tax ID:</td>
          <td className="pl-2">{contact.organizationTaxId || "-"}</td>
        </tr>

        {contact.organizationSubTypes &&
          (contact.organizationSubTypes as string[]).includes(
            "Medical Provider",
          ) && (
            <>
              <tr className="table-row">
                <td>Medical provider accepts liens?:</td>
                <td className="pl-2">
                  {contact.organizationMedicalProviderAcceptsLiens
                    ? "Yes"
                    : "No"}
                </td>
              </tr>
              <tr className="table-row">
                <td>Medical provider specializations:</td>
                <td className="pl-2">
                  {contact.organizationMedicalProviderSpecialization?.join(
                    ", ",
                  ) || "-"}
                </td>
              </tr>
            </>
          )}
      </tbody>
    </table>
  );
};
